import React from 'react';
import { useTranslation } from 'react-i18next';
import AudioTabs from '../components/common/AudioTabs';

export default function SoundEffectPage() {
  const { t } = useTranslation(['library', 'app']);

  return (
    <div className="flex h-screen bg-bg-page">
      <div className="w-96 bg-bg-surface border-r border-border-subtle shadow-xl">
        <AudioTabs />
      </div>

      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-50 mb-4">{t('library:soundEffect.title')}</h1>
          <p className="text-xl text-gray-400">{t('app:comingSoon')}</p>
        </div>
      </div>
    </div>
  );
}